import {
    messageListMinorTextNext,
    messageListMajorTextNext,
    firstLineThreeCol,
    firstLineThreeColDenseless,
    full,
    medium,
    mediumTypeRampUpdates,
} from './messageListTextStyles.scss';

import { getDensityModeCssClass } from 'owa-fabric-theme';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import classnames from 'owa-classnames';

export const useMessageListTextStyle = (
    textType: 'Minor' | 'Major',
    isFirstLine?: boolean,
    isSingleLineView?: boolean
): string => {
    const isTypeRampUpdatesEnabled = isGlobalFeatureEnabled('mon-type-ramp');
    // Get the Proper text styles
    return classnames(
        textType == 'Minor' ? messageListMinorTextNext : messageListMajorTextNext,
        isSingleLineView !== undefined &&
            !isSingleLineView &&
            isFirstLine &&
            (isTypeRampUpdatesEnabled ? firstLineThreeColDenseless : firstLineThreeCol),
        isTypeRampUpdatesEnabled
            ? mediumTypeRampUpdates
            : getDensityModeCssClass(full, medium, undefined)
    );
};
